"use client";

import { BellIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

/**
 * Watch a record, session or channel for activity. WorkspaceNotificationWatch
 * Button loads and saves the watch; this is its control.
 */
export function WorkspaceNotificationWatchButtonView({
  watched,
  loadFailed = false,
  saving = false,
  onToggle,
}: {
  /** Undefined while the current watch is loading. */
  watched: boolean | undefined;
  loadFailed?: boolean;
  saving?: boolean;
  onToggle?: () => void;
}) {
  const label = loadFailed ? "Retry watch" : watched ? "Watching" : "Watch";
  return (
    <Button
      type="button"
      size="sm"
      variant={watched ? "secondary" : "outline"}
      disabled={(watched === undefined && !loadFailed) || saving}
      aria-pressed={watched ?? false}
      onClick={onToggle}
    >
      <BellIcon aria-hidden="true" />
      {saving ? "Saving…" : label}
    </Button>
  );
}
